module.exports = __webpack_public_path__ + "static/media/black-tshirt-man-front-min.5c3e91f4.png";